import createIcon from '../../createIcon';

/**
 * @component @name Fourteenmp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNy41IDE0SDguNVYxN0gxMFYxNEgxMVYxOC41SDEyLjVWMTMuNUMxMi41IDEyLjk1IDEyLjA1IDEyLjUgMTEuNSAxMi41SDdDNi40NSAxMi41IDYgMTIuOTUgNiAxMy41VjE4LjVINy41VjE0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzLjUgMTIuNVYxOC41SDE1VjE3SDE3QzE3LjU1IDE3IDE4IDE2LjU1IDE4IDE2VjEzLjVDMTggMTIuOTUgMTcuNTUgMTIuNSAxNyAxMi41SDEzLjVaTTE2LjUgMTUuNUgxNVYxNEgxNi41VjE1LjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xOSAxOUg1VjVIMTlWMTlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNOC41IDExLjVIMTBWNS41SDdWN0g4LjVWMTEuNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNSAxMS41SDE2LjVWMTBIMTcuNVY4LjVIMTYuNVY1LjVIMTVWOC41SDEzLjVWNS41SDEyVjEwSDE1VjExLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fourteenmp = createIcon('Fourteenmp', [
  [
    'path',
    {
      d: 'M7.5 14H8.5V17H10V14H11V18.5H12.5V13.5C12.5 12.95 12.05 12.5 11.5 12.5H7C6.45 12.5 6 12.95 6 13.5V18.5H7.5V14Z',
      key: '16tfpp',
    },
  ],
  [
    'path',
    {
      d: 'M13.5 12.5V18.5H15V17H17C17.55 17 18 16.55 18 16V13.5C18 12.95 17.55 12.5 17 12.5H13.5ZM16.5 15.5H15V14H16.5V15.5Z',
      key: '1uc7ij',
    },
  ],
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z',
      key: 'i1bke7',
    },
  ],
  ['path', { d: 'M8.5 11.5H10V5.5H7V7H8.5V11.5Z', key: 'w03j1e' }],
  [
    'path',
    { d: 'M15 11.5H16.5V10H17.5V8.5H16.5V5.5H15V8.5H13.5V5.5H12V10H15V11.5Z', key: 'fz3vym' },
  ],
]);

export default Fourteenmp;
